import React from "react";

/**
 * ConfirmPH brand logo.
 *
 * Renders the official ConfirmPH lockup (icon + wordmark) from the
 * static public asset. The image already contains the "ConfirmPh"
 * wordmark, so DO NOT render extra text next to it.
 *
 * Variants:
 *   - "full"      : full stacked lockup (icon above text)
 *   - "icon"      : icon-only mark (for tight spaces / favicons)
 *
 * Sizing is controlled via Tailwind classNames (e.g., "h-10", "h-14").
 * The image preserves its intrinsic aspect ratio.
 */
export function BrandLogo({
  variant = "full",
  className = "h-10 w-auto",
  alt = "ConfirmPH",
  testId = "brand-logo",
  ...rest
}) {
  const src = variant === "icon" ? "/brand/confirmph-icon.png" : "/brand/confirmph-logo.png";
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      data-testid={testId}
      decoding="async"
      loading="eager"
      {...rest}
    />
  );
}

export default BrandLogo;
